import { render, staticRenderFns } from "./OTSMissingCardsConnection.vue?vue&type=template&id=4cf2dbf0"
import script from "./OTSMissingCardsConnection.vue?vue&type=script&lang=js"
export * from "./OTSMissingCardsConnection.vue?vue&type=script&lang=js"
import style0 from "./OTSMissingCardsConnection.vue?vue&type=style&index=0&id=4cf2dbf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports